module.exports = __webpack_public_path__ + "img/15.862b19b6.png";